// Indexed by a dynamically-uppercased province code from live dispensary data
// (see packages/shared/order/fees.js), so this stays a plain string index
// rather than a literal union of province codes — narrowing it would force a
// cast at that lookup site rather than catch a real bug.
export const canadianFeeTaxes: Record<string, number> = {
  ON: 0.13,
  NB: 0.15,
  NL: 0.15,
  NS: 0.15,
  PE: 0.15,
  BC: 0.12,
  default: 0.05,
};

export const taxPercentPrecision = 100000;
